import React from "react";
import { useState } from "react";
import { FaBars } from "react-icons/fa";
import { SiReactos } from "react-icons/si";
import { HiX } from "react-icons/hi"
import { Link } from "react-router-dom";
import './styles.scss'
import { navmenu } from "./utils";

const Navbar = () => {
    const [toggle, setToggle] = useState(false)
    const handleToggle = () => {
        setToggle(!toggle)
    }
    return (
      <div>
        <nav className="navbar">
          <div className="navbar__container">
            <Link to="/" className="navbar__container__logo">
              <SiReactos size={30} />
            </Link>
          </div>
          <ul className={`navbar__container__menu ${toggle ? "active" : ""}`}>
            {navmenu.map((item, i) => (
              <li key={i} className="navbar__container__menu__item">
                <Link
                  onClick={handleToggle}
                  to={item.to}
                  className="navbar__container__menu__item__links"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="nav-icon" onClick={handleToggle}>
            {toggle ? <HiX size={30} /> : <FaBars size={30} />}
          </div>
        </nav>
      </div>
    );
};

export default Navbar;
